/** Когда напоминать взрослому, что занятия держатся на одном устройстве.
 *
 *  Вынесено отдельной чистой функцией, чтобы правило проверялось прогоном, а
 *  не глазами по компоненту, и чтобы «раз в сутки» означало ровно одно.
 *
 *  Три условия, и каждое отсекает свой вид назойливости:
 *
 *  - **Есть учётная запись — не напоминаем.** Занятия уезжают, терять
 *    нечего. Про неотправленное говорит строка обмена, а не окно поперёк
 *    экрана: она стоит там всегда и не требует нажатия.
 *  - **Терять нечего — не напоминаем.** Ни одной пройденной тренировки:
 *    окно «вы можете потерять занятия» перед первым же занятием пугает
 *    впустую и учит закрывать не глядя.
 *  - **Не чаще раза в сутки.** Ребёнок садится заниматься по нескольку раз
 *    в день, и окно перед каждым занятием — это способ добиться, чтобы его
 *    перестали читать.
 *
 *  Время приходит доводом, а не берётся из `Date.now()`: то же правило, что
 *  и в движке, и по той же причине — иначе «раз в сутки» нечем проверить. */
export function shouldRemind(
  { signedIn, unsent, lastShownMs, nowMs }:
    { signedIn: boolean; unsent: number; lastShownMs: number | null; nowMs: number },
): boolean {
  if (signedIn) return false;
  if (unsent <= 0) return false;
  if (lastShownMs === null) return true;
  /** Отметка из будущего — сбитые часы устройства или перевод назад.
   *  Считаем, что напоминать пора: иначе одна кривая отметка выключила бы
   *  напоминание навсегда. */
  if (lastShownMs > nowMs) return true;
  return nowMs - lastShownMs >= DAY_MS;
}

export const DAY_MS = 24 * 60 * 60 * 1000;

const KEY = 'mathpaw.local-only-reminded';

/** Отметка живёт в localStorage, а не в базе: она про это устройство и этот
 *  браузер, переживать очистку учебных данных ей незачем, а обращение
 *  БРОСАЕТ в приватном окне — поэтому обёрнуто. */
export function readLastShown(): number | null {
  try {
    const raw = window.localStorage.getItem(KEY);
    if (raw === null) return null;
    const value = Number(raw);
    return Number.isFinite(value) ? value : null;
  } catch {
    return null;
  }
}

export function writeLastShown(nowMs: number): void {
  try {
    window.localStorage.setItem(KEY, String(nowMs));
  } catch {
    /* Приватное окно: напоминание придёт ещё раз, и это не беда. */
  }
}
